var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopic(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Artwork",
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.39,14V9.47l-4-2.29V3.78h-.86v3.4l-4,2.29V14l-3,1.75.43.74,3-1.75H8l4,2.28,4-2.28,2.93,1.69.43-.74Zm-2.33.88a.83.83,0,0,1-.69-.39H9.13v-.85h4.24a.83.83,0,0,1,.69-.39.82.82,0,0,1,0,1.63Zm.81-2.49H12.7a.81.81,0,0,1-1.4,0H9.13v-.86h2.19a.81.81,0,0,1,1.36,0h2.19Zm0-2.11H10.63a.83.83,0,0,1-.69.39.82.82,0,0,1,0-1.63.83.83,0,0,1,.69.39h4.24Z",
    style: {
      fill: "#4285f4"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.56,7.56v8.87a.87.87,0,0,1-.44.76l-7.68,4.44a.88.88,0,0,1-.44.12V20.16l7.07-4.08V7.92L12,3.84V2.25a1,1,0,0,1,.44.11L20.12,6.8A.89.89,0,0,1,20.56,7.56Z",
    style: {
      fill: "#669df6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.44,7.56v8.87a.87.87,0,0,0,.44.76l7.68,4.44a.88.88,0,0,0,.44.12V20.16L4.93,16.08V7.92L12,3.84V2.25a1,1,0,0,0-.44.11L3.88,6.8A.89.89,0,0,0,3.44,7.56Z",
    style: {
      fill: "#aecbfa"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopic);
export default __webpack_public_path__ + "static/media/topic.09a48b8a80e3c6829a310ddcf42f2e77.svg";
export { ForwardRef as ReactComponent };